// 获取node节点的所有父级节点
export function getParentNodes(node){
	var parents = []

	while(node.parentNode){
		parents.push(node.parentNode)

		node = node.parentNode
	}

	return parents
}